<template>
  <div class="container">
    <v-progress-circular
      v-if="loading && !error"
      color="primary"
      indeterminate
    />
    <p v-if="!loading && error" class="error-message">
      {{ $t('signIn.external-login-generic-error') }}
    </p>
  </div>
</template>

<script>
import {mapMutations, mapActions} from 'vuex'

export default {
  data() {
    return {
      loading: true,
      error: false
    }
  },
  mounted() {
    this.setHideAppUI(true)
    this.doLogin()
  },
  beforeDestroy() {
    this.setHideAppUI(false)
  },
  methods: {
    ...mapMutations(['setHideAppUI']),
    ...mapActions(['externalLogin']),
    async doLogin() {
      try {
        await this.externalLogin(
          this.$route.params.token
        )

        this.loading = false
        this.$router.push({name: 'home'})
      } catch (error) {
        this.loading = false
        this.error = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.error-message {
  text-align: center;
  max-width: 320px;
}
</style>
